export const observeListEnd = {
    data() {
        return {

        }
    },
    methods: {
        observeListEnd(tab, tabs=false, remove=false, update=false) {

            let moreIndex, observer;

            const end = () => {
                moreIndex = tabs ? tabs[tab].moreIndex : this.moreIndex;

                if (
                    this.$refs[tab + moreIndex] &&
                    this.$refs[tab + moreIndex][0] &&
                    this.$refs[tab + moreIndex][0].$el
                ) {
                    return this.$refs[tab + moreIndex][0].$el;
                } else if (
                    this.$refs[tab + moreIndex] &&
                    this.$refs[tab + moreIndex][0]
                ) {
                    return this.$refs[tab + moreIndex][0];
                } else if (
                    this.$refs[tab + moreIndex] &&
                    this.$refs[tab + moreIndex].$el
                ) {
                    return this.$refs[tab + moreIndex].$el;
                } else if (this.$refs[tab + moreIndex]) {
                    return this.$refs[tab + moreIndex]
                } else {
                    return false;
                }
            }

            let promise = new Promise(function(resolve, reject) {
                let count = 0;

                let checkEnd = () => {
                    setTimeout(() => {
                        if (end()) {
                            resolve(end());
                        } else if (count < 6) {
                            count++;
                            checkEnd();
                        } else {
                            reject();
                        }
                    }, 100);
                }
                checkEnd();
            });

            promise
            .then((el) => {
                observer = tabs ? tabs[tab].observer : this.observer;
                if (remove) {
                    observer.unobserve(el);
                } else {
                    observer.observe(el);
                }
                if (update) {
                    this.updateMoreIndex(tab);
                    this.observeListEnd(tab, tabs);
                }
            })
            .catch(() => {
                // console.log('el is null');
            });
        },
        updateTabObserver(tab, tabs) {
            this.observeListEnd(tab, tabs);
        },
        observeListStart(tab, tabs=false, remove=false, update=false) {

            let morePrevIndex, observerPrev;

            const start = () => {
                morePrevIndex = tabs ? tabs[tab].morePrevIndex : this.morePrevIndex;
                if (
                    this.$refs[tab + morePrevIndex] &&
                    this.$refs[tab + morePrevIndex][0]
                ) {
                    return this.$refs[tab + morePrevIndex][0];
                } else if (this.$refs[tab + morePrevIndex]) {
                    return this.$refs[tab + morePrevIndex]
                } else {
                    return false;
                }
            }

            let promise = new Promise(function(resolve, reject) {
                let count = 0;

                let checkStart = () => {
                    setTimeout(() => {
                        if (start()) {
                            resolve(start());
                        } else if (count < 6) {
                            count++;
                            checkStart();
                        } else {
                            reject();
                        }
                    }, 100);
                }
                checkStart();
            });

            promise
            .then((el) => {
                observerPrev = tabs ? tabs[tab].observerPrev : this.observerPrev;
                if (remove) {
                    observerPrev.unobserve(el);
                } else {
                    observerPrev.observe(el);
                }
                if (update) {
                    this.updateMorePrevIndex(tab);
                    this.observeListStart(tab, tabs);
                }
            })
            .catch(() => {
                // console.log('el is null');
            });
        }
    }
}
